<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="项目/联系人/电话" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.customer_id"  clearable filterable  placeholder="甲方">
                                        <Option :value="item.id" v-for="(item,index) in customerList" :key="index">{{item.company}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.type_id"  clearable filterable  placeholder="类型">
                                        <Option :value="item.type_id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.head_id"  clearable filterable  placeholder="负责人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.work_id"  clearable filterable  placeholder="施工人员">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 创建项目</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="project_id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" fixed-shadow="hide" no-data-text="暂无数据记录">
                                <template #name="{ row }">
                                    <div @click="showData(row.project_id)" class="d-width text-primary cursor" :title="row.name">
                                        <span>{{row.name}}</span>
                                    </div>
                                </template>
                                <template #type_id="{ row }">
                                    <div class="d-width" :title="row.type_name">
                                        <Tag>{{row.type_name}}</Tag>
                                    </div>
                                </template>
                                <template #money="{ row }">
                                    <div class="d-width" :title="row.money">
                                        <strong class="text-violet">{{row.money}}</strong>
                                    </div>
                                </template>
                                <template #collection_money="{ row }">
                                    <div class="d-width" :title="row.collection_money">
                                        <strong class="text-success">{{row.collection_money??'0.00'}}</strong>
                                    </div>
                                </template>
                                <template #debt_money="{ row }">
                                    <div class="d-width" :title="row.debt_money">
                                        <strong class="text-danger">{{row.debt_money??'0.00'}}</strong>
                                    </div>
                                </template>
                                <template #expend_money="{ row }">
                                    <div class="d-width" :title="row.expend_money">
                                        <strong class="text-orange">{{row.expend_money??'0.00'}}</strong>
                                    </div>
                                </template>
                                <template #invoice_money="{ row }">
                                    <div class="d-width" :title="row.invoice_money">
                                        <strong class="text-primary">{{row.invoice_money??'0.00'}}</strong>
                                    </div>
                                </template>
                                <template #work_expected_time="{ row }">
                                    <div class="d-width" :title="row.work_expected_time">
                                        {{row.work_expected_time?row.work_expected_time:'-'}}
                                    </div>
                                </template>
                                <template #start_work_time="{ row }">
                                    <div class="d-width" :title="row.start_work_time">
                                        {{row.start_work_time?row.start_work_time:'-'}}
                                    </div>
                                </template>
                                <template #success_time="{ row }">
                                    <div class="d-width" :title="row.success_time">
                                        {{row.success_time?row.success_time:'-'}}
                                    </div>
                                </template>
                                <template #company="{ row }">
                                    <div @click="customerData(row.customer_id)" class="d-width cursor" :title="row.company">
                                        <Poptip trigger="hover" title="联系方式" >
                                            <span>{{row.company}}</span>
                                            <template #content>
                                                <p>公司：{{row.company}}</p>
                                                <p>称呼：{{row.customer_real_name}}</p>
                                                <p>电话：{{row.customer_mobile}}</p>
                                                <p v-if="!!row.customer_wechat">微信：{{row.customer_wechat}}</p>
                                            </template>
                                        </Poptip>
                                    </div>
                                </template>
                                <template #action="{ row }">
                                    <a class="text-font-sm text-violet" @click="logData(row.project_id, row.name)">日志</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 详情  -->
                    <show-modal v-if="is_show" ref="ShowRef"></show-modal>

                    <!-- 客户详情 -->
                    <customer-show-modal v-if="is_customer" ref="CustomerRef"></customer-show-modal>

                    <!-- 项目日志  -->
                    <log-modal v-if="is_log" ref="LogRef"></log-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import {getProjectConfig, getProjectSuccessList} from '@/apis/project'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "../public/Create";
import LogModal from "../public/Log";
import ShowModal from "../public/Show";
import CustomerShowModal from "../../customer/index/Show";
export default {
    name: "ProjectSuccess",
    components: {
        Headers, Side, AddModal, ShowModal, LogModal, CustomerShowModal
    },
    data () {
        return {
            typeList: [],
            customerList: [],
            userList: [],

            search: {
                name: '',
                type_id: '',
                customer_id: '',
                head_id: '',
                work_id: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    title: '项目名称',
                    key: 'name',
                    slot: 'name',
                    fixed:'left',
                    minWidth: 240,
                },
                {
                    title: '甲方',
                    key: 'company',
                    slot: 'company',
                    width: 220
                },
                {
                    title: '项目类型',
                    key: 'type_id',
                    slot: 'type_id',
                    width: 120
                },
                {
                    title: '项目预算',
                    key: 'budget_money',
                    width: 120
                },
                {
                    title: '项目报价',
                    key: 'quote_money',
                    width: 120
                },
                {
                    title: '合同金额',
                    key: 'contract_money',
                    width: 120
                },
                {
                    title: '项目金额',
                    key: 'money',
                    slot: 'money',
                    width: 120
                },
                {
                    title: '项目回款',
                    key: 'collection_money',
                    slot: 'collection_money',
                    width: 120
                },
                {
                    title: '项目坏账',
                    key: 'debt_money',
                    slot: 'debt_money',
                    width: 120
                },
                {
                    title: '项目支出',
                    key: 'expend_money',
                    slot: 'expend_money',
                    width: 120
                },
                {
                    title: '开票金额',
                    key: 'invoice_money',
                    slot: 'invoice_money',
                    width: 120
                },

                {
                    title: '开工日期',
                    key: 'start_work_time',
                    slot : 'start_work_time',
                    width:120
                },
                {
                    title: '完工日期',
                    key: 'work_expected_time',
                    slot : 'work_expected_time',
                    width:120
                },
                {
                    title: '结束日期',
                    key: 'success_time',
                    slot : 'success_time',
                    width:120
                },
                {
                    title: '负责人',
                    key: 'head_name',
                    width: 100
                },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    fixed:'right',
                    width : 70
                }
            ],
            is_create : false,
            is_show : false,
            is_log : false,
            is_customer : false,
        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        /**
         功能：
         time: 2026/1/4 13:57
         **/
        customerData(customer_id){
            let that = this;
            that.is_customer = true;
            setTimeout(function(){
                that.$refs.CustomerRef.show(customer_id);
            })
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                name: '',
                type_id: '',
                customer_id: '',
                head_id: '',
                work_id: ''
            };
            that.getList();
        },
        /**
         功能：
         time: 2025/12/18 14:07
         **/
        getConfig(){
            let that = this;
            getProjectConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.customerList = e.data.customerList ?? [];
                that.userList = e.data.userList ?? [];
            })
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getProjectSuccessList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/19 11:30
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：
         time: 2025/12/19 16:04
         **/
        saveData(){
            let that = this;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        logData(project_id, name ){
            let that = this;
            that.is_log = true;
            setTimeout(function(){
                that.$refs.LogRef.show(project_id, name);
            })
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        showData(project_id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowRef.show(project_id);
            })
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
